import { ApiService } from "./ApiService"

export class LogisticCategoryService {

    static uri = '/logistic/categories';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static store({ data }) {
        return ApiService.post(`${this.uri}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static update({ id, data }) {
        return ApiService.put(`${this.uri}/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static destroy({ id }) {
        return ApiService.delete(`${this.uri}/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }
}